import { ApiDataAdapter } from '@internal-libraries/kheops-ui-lib'
import { ClvrScreenControlTemplateDto } from '../Types/ClvrScreenControlTemplateDto'
import { get } from 'lodash'
import Group from '../../../dPetablissement/vue/Classes/Group'
import { ScreenControlTemplateData } from '../Types/ScreenControlTemplateData'
import { ClvrScreenControlDataTypeApiAdapter } from './ClvrScreenControlDataTypeApiAdapter'
import { ScreenControlDataTypeData } from '../Types/ScreenControlDataTypeData'

export class ClvrScreenControlTemplateApiAdapter implements ApiDataAdapter<ScreenControlTemplateData> {
    public createClass(apiData: ClvrScreenControlTemplateDto): ScreenControlTemplateData {
        const dataTypesApiData = get(apiData, '_ref_data_types', [])
        let dataTypes = dataTypesApiData.map(new ClvrScreenControlDataTypeApiAdapter().createClass)
        const dataTypesChildrenMap = new Map<number, ScreenControlDataTypeData[]>()
        dataTypes.forEach(item => {
            if (item.parentDataTypeId) {
                const value = dataTypesChildrenMap.get(item.parentDataTypeId)
                if (value) {
                    value.push(item)
                    dataTypesChildrenMap.set(item.parentDataTypeId, value)
                } else {
                    dataTypesChildrenMap.set(item.parentDataTypeId, [item])
                }
            }
        })

        dataTypes = dataTypes
            .map(item => {
                if (item.id && !item.parentDataTypeId) {
                    const value = dataTypesChildrenMap.get(item.id) || []
                    return value && value.length > 0 ? { ...item, dataTypeChildren: value } : item
                }
                return null
            })
            .filter((s): s is ScreenControlDataTypeData => !!s)

        return {
            id: get(apiData, 'id') || undefined,
            name: get(apiData, 'name'),
            isDataAggregated: get(apiData, 'is_data_aggregated'),
            isTrigramMode: get(apiData, 'is_trigram_mode'),
            isDoneInterventionHidden: get(apiData, 'is_done_intervention_hidden'),
            displayCancelledIntervention: get(apiData, 'display_cancelled_intervention'),
            refreshInterval: get(apiData, 'refresh_interval'),
            carouselInterval: get(apiData, 'carousel_interval'),
            creationDate: get(apiData, 'creation_date'),
            aliasOption: get(apiData, 'alias_option'),
            updateDate: get(apiData, 'update_date'),
            dataTypes: dataTypes,
            establishments: Group.instantiateGroupsFromDto(get(apiData, '_establishments')),
        }
    }
}
